(function () {
    const payload = window.__BC_SECTIONS_TREE__ || { roots: [], map: {} };
    const map = payload.map || {};
    const tableId = window.__BC_TABLEID__ || "";

    // helpers
    function getNode(id) { return map[id] || null; }
    function childrenOf(id) {
        const n = getNode(id);
        return (n && Array.isArray(n.children)) ? n.children : [];
    }
    function hasChildren(id) {
        const ch = childrenOf(id);
        return ch.some(cid => {
            const c = getNode(cid);
            return c && !c.hide;
        });
    }
    function shouldInterceptTapToOpen(id) {
        return !!id && hasChildren(id);
    }
    function getSelectedSectionId() {
        const u = new URL(window.location.href);
        return (u.searchParams.get("y") || "").trim();
    }
    const selectedSectionId = getSelectedSectionId();


    function sortedVisibleChildren(parentId) {
        const ids = childrenOf(parentId);
        const arr = ids
            .map(cid => getNode(cid))
            .filter(x => x && !x.hide);

        arr.sort((a, b) => {
            const ao = (typeof a.order === "number") ? a.order : 999999;
            const bo = (typeof b.order === "number") ? b.order : 999999;
            if (ao !== bo) return ao - bo;
            return (a.desc || "").localeCompare((b.desc || ""), "es");
        });
        return arr;
    }

    // popup
    const pop = document.createElement("div");
    pop.className = "bc-subpop";
    pop.innerHTML = `
    <div class="bc-subpop__head">
      <button class="bc-subpop__back" type="button" style="visibility:hidden">← Atrás</button>
      <div class="bc-subpop__title"></div>
      <span style="width:34px"></span>
    </div>
    <div class="bc-subpop__list"></div>
  `;
    document.body.appendChild(pop);

    const elBack = pop.querySelector(".bc-subpop__back");
    const elTitle = pop.querySelector(".bc-subpop__title");
    const elList = pop.querySelector(".bc-subpop__list");

    let anchor = null;
    let openTimer = null;
    let closeTimer = null;
    let stack = [];
    let currentParentId = "";

    const isTouch =
        ("ontouchstart" in window) ||
        (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);

    let lastTapId = "";
    let lastTapAt = 0;
    const DOUBLE_TAP_MS = 650;

    function clearTimers() {
        if (openTimer) clearTimeout(openTimer), openTimer = null;
        if (closeTimer) clearTimeout(closeTimer), closeTimer = null;
    }

    function placeNear(el) {
        const r = el.getBoundingClientRect();
        const margin = 8;

        let x = r.left;
        let y = r.bottom + margin;

        pop.style.left = "0px";
        pop.style.top = "0px";

        pop.classList.remove("hiding");
        pop.classList.add("show");

        const pr = pop.getBoundingClientRect();

        if (x + pr.width > window.innerWidth - 8) x = window.innerWidth - pr.width - 8;
        if (x < 8) x = 8;

        if (y + pr.height > window.innerHeight - 8) {
            y = r.top - pr.height - margin;
            if (y < 8) y = 8;
        }

        pop.style.left = `${Math.round(x)}px`;
        pop.style.top = `${Math.round(y)}px`;
    }

    function render(parentId, title, direction /* "forward" | "back" | null */) {
        currentParentId = parentId || "";
        elTitle.textContent = title || "";

        // limpiamos lista y creamos una "page" animable
        elList.innerHTML = "";
        const page = document.createElement("div");
        page.className = "bc-subpop__page";

        if (direction === "forward") page.classList.add("anim-in-left");
        if (direction === "back") page.classList.add("anim-in-right");

        elBack.style.visibility = stack.length > 0 ? "visible" : "hidden";

        const children = sortedVisibleChildren(currentParentId);

        for (const c of children) {
            const row = document.createElement("div");
            row.className = "bc-subpop__item";
            row.setAttribute("data-id", c.id);

            if (selectedSectionId && c.id === selectedSectionId) {
                row.classList.add("is-active");
            }

            const has = hasChildren(c.id);

            row.innerHTML = `
              <div class="bc-subpop__left" title="${(c.desc || "").toLowerCase()}">
                <span class="bc-subpop__label">${(c.desc || "").toLowerCase()}</span>
              </div>
              <div class="bc-subpop__right">
                ${has ? `<button class="bc-subpop__go" type="button" title="Ir a esta categoría">Ir</button>` : ``}
                ${has ? `<span class="bc-subpop__chev">›</span>` : `<span style="width:10px"></span>`}
              </div>
            `;

            const goBtn = row.querySelector(".bc-subpop__go");
            if (goBtn) {
                goBtn.addEventListener("click", (ev) => {
                    ev.stopPropagation();
                    const url = `/Home?hfty=${encodeURIComponent(tableId)}&y=${encodeURIComponent(c.id)}`;
                    window.location.href = url;
                });
            }

            row.addEventListener("click", (ev) => {
                ev.stopPropagation();

                if (has) {
                    stack.push({ id: currentParentId, title: elTitle.textContent });
                    render(c.id, (c.desc || "").toLowerCase(), "forward");
                    if (anchor) placeNear(anchor);
                } else {
                    const url = `/Home?hfty=${encodeURIComponent(tableId)}&y=${encodeURIComponent(c.id)}`;
                    window.location.href = url;
                }
            });

            page.appendChild(row);
        }

        elList.appendChild(page);
    }


    function openFor(a) {
        if (a && a.closest && a.closest("#more-dropdown")) return;

        anchor = a;
        stack = [];

        const id = a.getAttribute("data-sec-id") || "";
        if (!id || !hasChildren(id)) return;

        const n = getNode(id);
        const title = ((n?.desc) || a.textContent || "").trim().toLowerCase();

        render(id, title, null);
        placeNear(a);
    }

    function close() {
        if (!pop.classList.contains("show")) return;

        pop.classList.add("hiding");
        pop.classList.remove("show");

        setTimeout(() => {
            pop.classList.remove("hiding");
            anchor = null;
            stack = [];
            currentParentId = "";
        }, 180); 
    }

    elBack.addEventListener("click", (ev) => {
        ev.stopPropagation();
        const prev = stack.pop();
        if (!prev) return;
        render(prev.id, prev.title, "back");
        if (anchor) placeNear(anchor);
    });

    pop.addEventListener("mouseenter", () => { clearTimers(); });
    pop.addEventListener("mouseleave", () => {
        clearTimers();
        closeTimer = setTimeout(close, 180);
    });

    document.addEventListener("click", (ev) => {
        if (!pop.classList.contains("show")) return;
        if (pop.contains(ev.target)) return;
        if (anchor && anchor.contains(ev.target)) return;
        close();
    });

    window.addEventListener("resize", () => { if (anchor && pop.classList.contains("show")) placeNear(anchor); });
    window.addEventListener("scroll", () => { if (anchor && pop.classList.contains("show")) placeNear(anchor); }, true);

    function bind() {
        const links = document.querySelectorAll(
            "a.bc-sec-link[data-sec-id]:not(#more-dropdown a)"
        );

        links.forEach(a => {
            const id = a.getAttribute("data-sec-id") || "";

            a.addEventListener("mouseenter", () => {
                if (isTouch) return; 
                clearTimers();
                openTimer = setTimeout(() => openFor(a), 120);
            });

            a.addEventListener("mouseleave", () => {
                if (isTouch) return;
                clearTimers();
                closeTimer = setTimeout(close, 180);
            });

            a.addEventListener("pointerdown", (ev) => {
                if (!isTouch) return;
                if (ev.pointerType !== "touch") return;

                if (!shouldInterceptTapToOpen(id)) return;

                const now = Date.now();
                const isSame = (lastTapId === id) && (now - lastTapAt <= DOUBLE_TAP_MS);
                lastTapId = id;
                lastTapAt = now;

                const popupOpenForThis =
                    pop.classList.contains("show") && anchor === a;

                if (!popupOpenForThis && !isSame) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    openFor(a);
                    return;
                }

            }, { passive: false });

            a.addEventListener("click", (ev) => {
                if (!isTouch) return;
            });
        });

        initMoreDropdown();
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bind);
    else bind();

    document.addEventListener("bc:sections-updated", bind);


    // TOUCH
    window.addEventListener("scroll", () => {
        if (isTouch && pop.classList.contains("show")) close();
    }, { passive: true });

    document.addEventListener("pointerdown", (ev) => {
        if (!isTouch) return;
        if (!pop.classList.contains("show")) return;
        if (pop.contains(ev.target)) return;
        if (anchor && anchor.contains(ev.target)) return;
        close();
    }, { passive: true });


    // dropdown overflow handling
    document.addEventListener("bc:sections-updated", () => {
        bind();            
        initMoreDropdown();
    });

    function initMoreDropdown() {
        const dropdown = document.getElementById("more-dropdown");
        if (!dropdown) return;

        // 1) Panel único reutilizable (NO lo dejamos fijo abajo)
        let panel = dropdown.querySelector(".bc-morepanel");
        if (!panel) {
            panel = document.createElement("div");
            panel.className = "bc-morepanel";
            panel.innerHTML = `
      <div class="bc-morepanel__head">
        <button class="bc-morepanel__back" type="button" style="visibility:hidden">← Atrás</button>
        <div class="bc-morepanel__title"></div>
        <span style="width:34px"></span>
      </div>
      <div class="bc-morepanel__list"></div>
    `;
            dropdown.appendChild(panel);
        }

        const backBtn = panel.querySelector(".bc-morepanel__back");
        const titleEl = panel.querySelector(".bc-morepanel__title");
        const listEl = panel.querySelector(".bc-morepanel__list");

        let stack2 = [];
        let currentId2 = "";
        let currentAnchor2 = null;

        function mountPanelUnder(anchor) {
            if (!anchor) return;
            // mover el panel justo debajo del <a> clickeado
            anchor.insertAdjacentElement("afterend", panel);
            panel.classList.add("show");
            currentAnchor2 = anchor;
        }

        function render2(parentId, title, direction) {
            currentId2 = parentId || "";
            titleEl.textContent = (title || "").toUpperCase();

            listEl.innerHTML = "";
            const page = document.createElement("div");
            page.className = "bc-morepanel__page";
            if (direction === "forward") page.classList.add("anim-in-left");
            if (direction === "back") page.classList.add("anim-in-right");

            backBtn.style.visibility = stack2.length > 0 ? "visible" : "hidden";

            const children = sortedVisibleChildren(currentId2);

            for (const c of children) {
                const row = document.createElement("div");
                row.className = "bc-subpop__item";
                const has = hasChildren(c.id);

                row.innerHTML = `
        <div class="bc-subpop__left">
          <span class="bc-subpop__label">${(c.desc || "").toLowerCase()}</span>
        </div>
        <div class="bc-subpop__right">
          ${has ? `<button class="bc-subpop__go" type="button">Ir</button>` : ``}
          ${has ? `<span class="bc-subpop__chev">›</span>` : `<span style="width:10px"></span>`}
        </div>
      `;

                const goBtn = row.querySelector(".bc-subpop__go");
                if (goBtn) {
                    goBtn.addEventListener("click", (ev) => {
                        ev.stopPropagation();
                        const url = `/Home?hfty=${encodeURIComponent(tableId)}&y=${encodeURIComponent(c.id)}`;
                        window.location.href = url;
                    });
                }

                row.addEventListener("click", (ev) => {
                    ev.stopPropagation();
                    if (has) {
                        stack2.push({ id: currentId2, title: titleEl.textContent });
                        render2(c.id, (c.desc || "").toLowerCase(), "forward");
                    } else {
                        const url = `/Home?hfty=${encodeURIComponent(tableId)}&y=${encodeURIComponent(c.id)}`;
                        window.location.href = url;
                    }
                });

                page.appendChild(row);
            }

            listEl.appendChild(page);
        }

        backBtn.onclick = (ev) => {
            ev.stopPropagation();
            const prev = stack2.pop();
            if (!prev) return;
            render2(prev.id, prev.title, "back");
        };

        // 2) Bind a links del dropdown: si tiene hijos => acordeón debajo del link
        dropdown.querySelectorAll("a.bc-sec-link[data-sec-id]").forEach(a => {
            // evitar múltiples binds si re-ejecutás initMoreDropdown()
            if (a.dataset.moreBound === "1") return;
            a.dataset.moreBound = "1";

            a.addEventListener("click", (ev) => {
                const id = a.getAttribute("data-sec-id") || "";
                if (!id) return;

                if (hasChildren(id)) {
                    ev.preventDefault();
                    ev.stopPropagation();

                    // que no quede el popup flotante abierto
                    close();

                    // toggle: si clickeás la misma categoría y estás en nivel root del panel, cerrá
                    const sameAnchor = (currentAnchor2 === a);
                    const sameRootLevel = (stack2.length === 0 && currentId2 === id);

                    if (sameAnchor && panel.classList.contains("show") && sameRootLevel) {
                        panel.classList.remove("show");
                        currentAnchor2 = null;
                        return;
                    }

                    mountPanelUnder(a);
                    stack2 = [];
                    const n = getNode(id);
                    render2(id, (n?.desc || a.textContent || "").trim().toLowerCase(), null);
                } else {
                    // sin hijos: dejar navegar y cerrar panel si estaba abierto
                    panel.classList.remove("show");
                    currentAnchor2 = null;
                }
            });
        });
    }
})();